import {
  DbliteContextState,
  useDblite,
} from '@pogokid/dblite/react'
import { ProfileProjectionState } from '@soniq/public-resource'

export function useDb(): DbliteContextState<ProfileProjectionState> {
  return useDblite() as unknown as DbliteContextState<ProfileProjectionState>
}
